import types from '../type/types.js'

export const setSleeve = sleeve => ({
    type: types.SET_SLEEVE,
    payload: sleeve
  })

  export default {}